import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, InfoText } from '@weezevent/nacre';
import css from './infoTextTooltip.module.css';

function TooltipContent({ title, subtitle = null }) {
    return (
        <span className={css['infotext-tooltip__span-tooltip']}>
            <div>{title}</div>
            {subtitle && <div>{subtitle}</div>}
        </span>
    );
}

export default function InfoTextTooltip({ title, subtitle, className, tooltip, children }) {
    return (
        <InfoText className={`${css['infotext-tooltip']} ${className}`} subtitle={subtitle}>
            <Tooltip visible={tooltip} triggerOnHover position={'top-start'} title={<TooltipContent title={title} subtitle={subtitle} />} margin={false}>
                {children || <span>{title}</span>}
            </Tooltip>
        </InfoText>
    );
}

InfoTextTooltip.propTypes = {
    className: PropTypes.string,
    subtitle: PropTypes.node,
    title: PropTypes.node.isRequired,
    tooltip: PropTypes.bool,
    children: PropTypes.node
};

InfoTextTooltip.defaultProps = {
    className: '',
    subtitle: null,
    title: '',
    tooltip: true,
    children: null
};
